import { apiClient } from '@/utils/api/client';

export interface SendOtpResponse {
  message: string;
}

export interface VerifyOtpResponse {
  success: boolean;
  message?: string;
  token?: string;
  email?: string;
  userId?: string;
}

export interface ValidateTokenResponse {
  valid: boolean;
  message?: string;
  code?: string;
  user?: {
    id: string;
    email: string;
    name?: string;
  };
}

export const authService = {
  async sendOtp(email: string): Promise<SendOtpResponse> {
    if (!isValidEmail(email)) {
      throw new Error('Invalid email format');
    }
    
    return await apiClient.post<SendOtpResponse>('/auth/request-otp', {
      email,
    });
  },

  async verifyOtp(email: string, otp: string): Promise<VerifyOtpResponse> {
    if (!isValidEmail(email)) {
      throw new Error('Invalid email format');
    }
    
    if (!/^\d{6}$/.test(otp)) {
      throw new Error('OTP must be 6 digits');
    }
    
    return await apiClient.post<VerifyOtpResponse>('/auth/verify-otp', {
      email,
      otp,
    });
  },

  async validateToken(): Promise<ValidateTokenResponse> {
    return await apiClient.post<ValidateTokenResponse>('/auth/validate-token', {});
  },

  async checkAuthStatus(): Promise<{ isAuthenticated: boolean; userId?: string; email?: string }> {
    try {
      const response = await apiClient.post<ValidateTokenResponse>('/auth/validate-token', {});
      return { 
        isAuthenticated: response.valid === true,
        userId: response.user?.id,
        email: response.user?.email
      };
    } catch {
      return { isAuthenticated: false };
    }
  },
};

// Email validation utility
function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}